import type { SizeTokens, Variable } from 'tamagui';

import { getTokens, getVariableValue } from 'tamagui';
type DimensionValue = number | 'auto' | `${number}%`;

const isTokenVariable = (
  value: unknown,
): value is Variable<unknown> =>
  typeof value === 'object' && value !== null && 'val' in value;

/**
 * @param sizeToken tamagui size token
 * @returns value for the sizeToken
 */
const getSizeTokenValue = (sizeToken: SizeTokens): DimensionValue => {
  const sizeTokens = getTokens({ prefixed: true }).size;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const maybeSpaceTokenObj = sizeTokens[sizeToken];

  if (
    typeof maybeSpaceTokenObj !== 'number' &&
    typeof maybeSpaceTokenObj !== 'string'
  ) {
    if (!isTokenVariable(maybeSpaceTokenObj)) {
      throw new Error(`Wrong size type for ${sizeToken}`);
    }

    return checkValueType(getVariableValue(maybeSpaceTokenObj));
  }

  return checkValueType(maybeSpaceTokenObj);
};

const checkValueType = (valueChecking: number | string): DimensionValue => {
  if (typeof valueChecking === 'string') {
    //This makes sure that the value is a number followed by a % sign
    if (/^\d+%$/.test(valueChecking)) {
      return valueChecking as DimensionValue;
    }

    throw new Error(`Wrong size type for ${valueChecking}`);
  }

  if (typeof valueChecking === 'number') {
    return valueChecking;
  }

  throw new Error(`Wrong size type for ${valueChecking}`);
};

export { getSizeTokenValue };
